import React from 'react';

const IconSoporte = (props) => (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.92173 9.99985H10.9217V6.99985L7.42173 3.49985C8.54136 2.96513 9.79923 2.79066 11.0221 3.00048C12.245 3.21029 13.3728 3.79407 14.2502 4.67143C15.1275 5.54878 15.7113 6.67656 15.9211 7.89946C16.1309 9.12235 15.9565 10.3802 15.4217 11.4999L21.4217 17.4999C21.8196 17.8977 22.043 18.4372 22.043 18.9999C22.043 19.5625 21.8196 20.102 21.4217 20.4999C21.0239 20.8977 20.4843 21.1212 19.9217 21.1212C19.3591 21.1212 18.8196 20.8977 18.4217 20.4999L12.4217 14.4999C11.3021 15.0346 10.0442 15.209 8.82133 14.9992C7.59843 14.7894 6.47066 14.2056 5.5933 13.3283C4.71595 12.4509 4.13217 11.3232 3.92235 10.1003C3.71254 8.87735 3.887 7.61948 4.42173 6.49985L7.92173 9.99985Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default IconSoporte;

